export const IUP_URL = "https://iup.teeup.dasliup.com.sg"
export const HEYBUDDY_URL = "https://heybuddy-admin.10tacle.io"